import React, { useState, useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import PropTypes from 'prop-types';
import { Acl } from 'modules/common/components/Acl';
import moment from 'moment';
import { ModalContext } from 'App';
import { getJson } from 'session';
import Pagination from 'modules/common/components/Pagination';
import { convertToTitleCase } from '../../../../helper';
import * as actions from '../actions';
import * as c from '../constant';
import ViewUploadModal from '../modals/ViewUploadModal';
import AddRecordModalBorongan from '../modals/AddRecordModalBorongan';

import ViewOfficialReceiptListingModal from '../modals/ViewOfficialReceiptListingModal';

const RPTBillingSmartCity = ({
  getListManualImportBorongan,
  list,
  isLoading,
  pager,
  getUploadedList,
  uploadList,
  pagerUpload,
  isLoadingUpload,
  deleteFileHistoryUpload,
  // deleteFileUpload,
  deleteRecordManualImportBorongan,
  permissions,
}) => {
  const [formData, setFormData] = useState({
    overwrite_previous: 0,
    is_active: 1,
  });
  const setModal = useContext(ModalContext);

  const [viewUploadHistory, setViewUploadHistory] = useState(false);

  const handleChangePage = (page) => {
    getListManualImportBorongan({ ...formData, page });
  };

  const handleChangePageUpload = (page) => {
    getUploadedList({ ...formData, page });
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  useEffect(() => {
    getListManualImportBorongan({ is_active: 1 });
  }, []);

  const onSearch = (e) => {
    e.preventDefault();
    getListManualImportBorongan(formData);
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      tdn_search: '',
      pin_search: '',
      year: '',
      account_name: '',
      official_receipt: '',
      is_active: 1,
    });
    getListManualImportBorongan({
      overwrite_previous: 0,
      is_active: 1,
    });
  };

  const formatPeriod = (data) => {
    return data
      ? data
          .replace('-1', ' - 1st quarter')
          .replace('-2', ' - 2nd quarter')
          .replace('-3', ' - 3rd quarter')
          .replace('-4', ' - 4th quarter')
      : '---';
  };

  const handleOnAllTransactions = (e) => {
    e.preventDefault();
    setViewUploadHistory(false);
    getListManualImportBorongan({ is_active: 1 });
  };

  const handleViewFailedRows = (dataInfo) => (e) => {
    e.preventDefault();
    setModal({
      title: 'View Failed Uploaded Files',
      isOpen: true,
      content: <ViewUploadModal dataInfo={dataInfo} />,
      modalSize: 'modal-xxl',
    });
  };

  const handleDeleteButtonClicked = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete ${
        _.get(data, 'attributes.bin') || 'this item'
      }?`,
      () => {
        // deleteFileUpload(data.id, () => {
          deleteRecordManualImportBorongan(data.id, () => {
          getListManualImportBorongan({ is_active: 1 });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleDeleteFileClicked = (data) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to delete ${
        _.get(data, 'attributes.file_name') || 'this item'
      }?`,
      () => {
        deleteFileHistoryUpload(data.id, () => {
          getListManualImportBorongan({ subject: 'RPTAX' });
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const handleAddModal = (e) => {
    e.preventDefault();
    setModal({  
      isOpen: true,
      content: <AddRecordModalBorongan type="ADD" />,
      title: 'Add New Record',
      modalSize: 'modal-xxl',
      modalContentSize: 'custom-size'
    });
  };

  const handleViewOfficialReceiptList = (data, id) => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewOfficialReceiptListingModal paymentListing={data} id={id} />, // rename to ViewOfficialReceiptListingModal
      title: 'View Official Receipts',
      modalSize: 'modal-lg',
    });
  };

  const handleUpdateFileClicked = (detail) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <AddRecordModalBorongan
          type="EDIT"
          dataInfo={detail.attributes}
          dataInclude={detail.included}
          id={detail.id}
        />
      ),
      title: `${_.get(detail, 'attributes.payment_status')?.toUpperCase()?.includes("PAID") ? "View Records" : "Edit Records" }`,
      modalSize: 'modal-xxl',
      modalContentSize: 'custom-size'
    });
  };

  const paymentStatusBadge = status => {

    if (status === 'PENDING') return (<span className='bg-warning px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    if (status === 'PAID') return (<span className='bg-success px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    if (status.includes('QUARTER')) return (<span className='bg-success px-2 rounded text-light'>{convertToTitleCase(status)}</span>)
    
    return '---'
  }

  return (
    <>
      <div className="d-flex justify-content-between align-items-center py-2 my-3 pl-2">
        <h2 className="mt-1 header-title font-weight-bold text-dark">
          Real Property Tax Billing
        </h2>
        <div className="d-flex">
          <div className="row-nav-end">
            {Acl(permissions, ['ADD RECORD RPTAX']) && (
              <button
                type="button"
                onClick={handleAddModal}
                className="btn btn-primary cms-bg-color-primary cms-outline-primary mr-2"
              >
                <i className="fa fa-plus py-2 mr-2" /> Add Record
              </button>
            )}
            {viewUploadHistory && (
              <div className="ml-auto">
                <button
                  type="button"
                  onClick={handleOnAllTransactions}
                  className="btn btn-link button-upload cms-bg-color-primary cms-outline-primary h-100"
                >
                  Back
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="p-4 billing-container">
        {!viewUploadHistory && (
          <form
            className="form-billing-container px-4 pt-4 d-flex justify-content-between"
            onSubmit={onSearch}
          >
            <div className="form-search-container d-flex flex-row">
              <div className="d-flex flex-column mr-2">
                <label className="label-title mb-2">TDN</label>
                <input
                  className="form-control-billing text-dark"
                  name="tdn_search"
                  onChange={onChange}
                  value={_.get(formData, 'tdn_search')}
                />
              </div>
              <div className="d-flex flex-column mr-2">
                <label className="label-title mb-2">PIN</label>
                <input
                  className="form-control-billing text-dark"
                  name="pin_search"
                  onChange={onChange}
                  value={_.get(formData, 'pin_search')}
                />
              </div>
              <div className="d-flex flex-column mr-2">
                <label className="label-title mb-2">Account Name/Owner ID</label>
                <input
                  className="form-control-billing text-dark"
                  placeholder='Account Name/Owner ID'
                  name="account_name"
                  onChange={onChange}
                  value={_.get(formData, 'account_name')?.toUpperCase()}
                />
              </div>
              <div className="d-flex flex-column mr-2">
                <label className="label-title mb-2">Official Receipt No.</label>
                <input
                  className="form-control-billing text-dark"
                  placeholder='Official Receipt No.'
                  name="official_receipt"
                  onChange={onChange}
                  value={_.get(formData, 'official_receipt')}
                />
              </div>
              <div className="search-div d-flex align-items-start ml-2 pt-4">
                <button
                  type="submit"
                  className="btn btn-link button-search cms-bg-color-secondary cms-outline-secondary"
                >
                  <div className="form-control-icon d-flex">
                    <span className="icon">
                      <i className="fa fa-lg fa-search" />
                    </span>
                    <span className="title-icon">Search</span>
                  </div>
                </button>
                <button
                  onClick={onClear}
                  type="button"
                  className="btn btn-link button-clear cms-bg-color-primary cms-outline-primary ml-2"
                >
                  <i className="fas fa-times" /> &nbsp;&nbsp; Clear
                </button>
              </div>
            </div>

            <div className="form-upload-container flex-column" />
          </form>
        )}
        {viewUploadHistory ? (
          <div className="card">
            <div className="card-body">
              <div className="table-billing-container">
                {isLoadingUpload ? (
                  <div
                    className="loading d-flex text-center justify-content-center align-items-center"
                    style={{ height: '500px' }}
                  >
                    <div className="spinner text-center ">
                      <span className="fas fa-5x fa-spin fa-spinner" />
                    </div>
                  </div>
                ) : (
                  <div className="table-scroll">
                    <table className="table table-sm table-hover" style={{ minWidth: '1700px' }}>
                      <thead className="table-header">
                        <tr className="billing-table-tr">
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            File Name
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Date Imported
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Failed Rows
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Total Rows
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Status
                          </th>
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <tbody className="table-details">
                        {uploadList.map((item) => {
                          return (
                            <tr
                              className="billing-table-tr"
                              key={_.get(item, 'id')}
                            >
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.file_name') || '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.date_imported')
                                  ? moment(
                                      `${_.get(
                                        item,
                                        'attributes.date_imported'
                                      )}`
                                    ).format('MMM DD, YYYY')
                                  : '---'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.failed_rows') || '0'}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.total_rows')}
                              </td>
                              <td className="py-3 align-middle">
                                {_.get(item, 'attributes.status')}
                              </td>
                              <td
                                className="p-3 align-middle"
                                style={{ width: '124px' }}
                              >
                                {_.get(item, 'attributes.failed_rows') > 0 ? (
                                  <>
                                    {Acl(permissions, [
                                      'RPT BILLINGS ALLOW DELETE',
                                    ]) && (
                                      <button
                                        type="button"
                                        className="btn-blank"
                                        onClick={handleDeleteFileClicked(item)}
                                      >
                                        <i className="far fa-trash-alt icon-delete" />
                                      </button>
                                    )}
                                    <button
                                      type="button"
                                      onClick={handleViewFailedRows(item)}
                                      className="btn-blank"
                                    >
                                      <i className="far fa-eye icon-view cms-bg-color-secondary" />
                                    </button>
                                  </>
                                ) : (
                                  <>
                                    {Acl(permissions, [
                                      'RPT BILLINGS ALLOW DELETE',
                                    ]) && (
                                      <button
                                        type="button"
                                        className="btn-blank"
                                        onClick={handleDeleteFileClicked(item)}
                                      >
                                        <i className="far fa-trash-alt icon-delete" />
                                      </button>
                                    )}
                                  </>
                                )}
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
                <div className="list-pagination">
                  {pagerUpload.total_pages > 1 ? (
                    <div className="d-flex justify-content-center text-center align-item-center">
                      <Pagination
                        data={pagerUpload}
                        onChange={handleChangePageUpload}
                      />
                    </div>
                  ) : (
                    ''
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <>
            {/* upload */}
            <div className="card">
              <div className="card-body">
                <div className="table-billing-container">
                  {isLoading ? (
                    <div
                      className="loading d-flex text-center justify-content-center align-items-center"
                      style={{ height: '500px' }}
                    >
                      <div className="spinner text-center ">
                        <span className="fas fa-5x fa-spin fa-spinner" />
                      </div>
                    </div>
                  ) : (
                    <div className="table-scroll">
                      <table className="table table-sm table-hover" style={{ minWidth: '1700px' }}>
                        <thead className="table-header">
                          <tr>
                            <th className="w-5 py-3 cms-text-primary cms-bg-color-primary-light align-middle text-center">
                              TDN
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                              PIN
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                              Account Name/Owner ID
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                              Official Receipt No
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                              Amount
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                              Status
                            </th> 
                            {Acl(permissions, ['VIEW RPTAX BILLING PAYMENT OR LISTS']) && (
                              <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                                Payment List
                              </th> 
                            )}
                            <th className={`py-3 cms-text-primary cms-bg-color-primary-light align-middle text-center ${Acl(permissions, ['RPTAX BILLINGS ALLOW DELETE']) === false && Acl(permissions, ['UPDATE RECORD RPTAX']) === false && "d-none"}`}>
                              Action
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                              Payment From
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                              Payment To
                            </th>
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle text-center">
                              Date Processed
                            </th>
                            {/* <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              Expiration Date
                            </th> */}
                            <th className="py-3 cms-text-primary cms-bg-color-primary-light  align-middle">
                              Delinquent
                            </th>
                          </tr>
                        </thead>
                        <tbody className="table-details">
                          {list.map((item) => {
                            return (
                              <tr
                                className="billing-table-tr"
                                key={_.get(item, 'id')}
                              >
                                <td className="py-3 align-middle">
                                  {_.get(item, 'attributes.tdn') || '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  {_.get(item, 'attributes.pin') || '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  {_.get(item, 'attributes.account_name') ||
                                    '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  0
                                </td>
                                <td className="py-3 align-middle">
                                  <b>PHP</b>&nbsp;
                                  {_.get(item, 'attributes.total_amount_human') || "0.00"}
                                </td>
                                <td className="py-3 align-middle">
                                  {paymentStatusBadge(_.get(item, 'attributes.payment_status'))}
                                </td>
                                {Acl(permissions, ['VIEW RPTAX BILLING PAYMENT OR LISTS']) && (
                                  <td className="py-3 align-middle">
                                    {/* or listing modal */}
                                    <button
                                      type="button"
                                      className="btn no-btn cms-text-primary"
                                      onClick={handleViewOfficialReceiptList(_.get(item, "attributes.payments"), _.get(item, "id"))}
                                    >
                                      <i className="fas fa-paperclip mr-2" /> View List
                                    </button>
                                  </td>
                                )}
                                <td className={`p-3 align-middle ${Acl(permissions, ['RPTAX BILLINGS ALLOW DELETE']) === false && Acl(permissions, ['UPDATE RECORD RPTAX']) === false && 'd-none'}`} style={{ width: '132px' }}>
                                  {Acl(permissions, [
                                    'UPDATE RECORD RPTAX',
                                  ]) && (
                                    <button   
                                      type="button"
                                      className="btn-blank"
                                      onClick={handleUpdateFileClicked(item)}
                                    >
                                      {_.get(item, 'attributes.payment_status')?.toUpperCase()?.includes("PAID") ? <i className="far fa-eye icon-view-only cms-bg-color-primary" /> : <i className="far fa-edit icon-edit cms-bg-color-primary" />}
                                    </button>
                                  )}
                                  {Acl(permissions, [
                                    'RPT BILLINGS ALLOW DELETE',
                                  ]) && (
                                    <button
                                      type="button"
                                      className="btn-blank"
                                      onClick={handleDeleteButtonClicked(item)}
                                    >
                                      <i className="far fa-trash-alt icon-delete" />
                                    </button>
                                  )}
                                </td>
                                <td className="py-3 align-middle">
                                  {formatPeriod(
                                    _.get(item, 'attributes.mode_of_payment_1')
                                  )}
                                </td>
                                <td className="py-3 align-middle">
                                  {formatPeriod(
                                    _.get(item, 'attributes.mode_of_payment_2')
                                  )}
                                </td>
                                <td className="py-3 align-middle">
                                  {/* {_.get(item, 'attributes.date_processed') */}
                                  {_.get(item, 'attributes.period_covered_from')
                                    ? moment(
                                        `${_.get(
                                          item,
                                          // 'attributes.date_processed'
                                          'attributes.period_covered_from'
                                        )}`
                                      ).format('MMM DD, YYYY')
                                    : '---'}
                                </td>
                                <td className="py-3 align-middle">
                                  {+_.get(item, 'attributes.is_delinquent')
                                    ? 'YES'
                                    : 'NO'}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  )}
                  <div className="list-pagination">
                    {pager.total_pages > 1 ? (
                      <div className="d-flex justify-content-center text-center align-item-center">
                        <Pagination data={pager} onChange={handleChangePage} />
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

RPTBillingSmartCity.propTypes = {
  getUploadedList: PropTypes.instanceOf(Function).isRequired,
  uploadList: PropTypes.instanceOf(Array).isRequired,
  getListManualImportBorongan: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  isLoadingUpload: PropTypes.bool.isRequired,
  list: PropTypes.instanceOf(Array).isRequired,
  pager: PropTypes.instanceOf(Object).isRequired,
  pagerUpload: PropTypes.instanceOf(Object).isRequired,
  // deleteFileUpload: PropTypes.instanceOf(Function).isRequired,
  deleteFileHistoryUpload: PropTypes.instanceOf(Function).isRequired,
  deleteRecordManualImportBorongan: PropTypes.instanceOf(Function).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  list: _.get(api, `${c.LIST_MANUAL_IMPORT}.list`) || [],
  uploadList: _.get(api, `${c.UPLOAD_LIST}.list`) || [],
  isLoading: _.get(api, 'loading', []).indexOf(c.LIST_MANUAL_IMPORT) > -1,
  pager: _.get(api, `${c.LIST_MANUAL_IMPORT}.pager`) || {},
  isLoadingUpload: _.get(api, 'loading', []).indexOf(c.UPLOAD_LIST) > -1,
  pagerUpload: _.get(api, `${c.UPLOAD_LIST}.pager`) || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(RPTBillingSmartCity);
